import React, { useState, useEffect, useRef } from 'react';

import { useReactToPrint } from 'react-to-print';

import { APIROOT } from '../../Helpers/configs';
import { useLocation, useNavigate } from 'react-router-dom';
import { convertDate, defineTicketNumber } from '../../Helpers/helpers';
import { GetAuth } from '../../Auth/AuthProvider';

import StockUsed from '../CommonComponents/StockUsed';

import InstallReportCustomerInfo from './InstallReportCustomerInfo';
import InstallReportChekList from './InstallReportChekList';
import InstallReportTraining from './InstallReportTraining';
import InstallReportCabinetDetails from './InstallReportCabinetDetails';
import InstallReportStockUsed from './InstallReportStockUsed';
import InstallReportNotes from './InstallReportNotes';
import InstallReportSignatures from './InstallReportSignatures';

import { viewBox } from '../shared/commonStyle';
import Logo from '../shared/Logo';
import DocsLogo from '../shared/DocsLogo';

import { Box, Stack, Grid, Typography, Button } from '@mui/material/';

// import './jc_print.css';
// import '../../Helpers/preventPrintBreak.css';
import '../../Helpers/print.css';

export default function InstallReport() {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const location = useLocation();
  const customerName = location.state.install_ticket_customer_name;

  const [ticketData, setTicketData] = useState({});

  const [checkListData, setCheckListData] = useState(
    location.state.install_report.check_list
  );
  const [trainingData, setTrainingData] = useState(
    location.state.install_report.training
  );

  useEffect(() => {
    getTicketDatabyId(location.state.install_ticket.id).then((data) => {
      setTicketData(data.data.value);
    });
  }, [location.state.install_ticket]);

  useEffect(() => {
    let data = location.state.install_ticket;
    if (data === null || data === undefined || data === {}) {
      setInstallReportInfo({
        // order_number: null,

        // grn_number: null,
        // gas: {
        //   type: 'Not Used',
        //   in: 0,
        //   out: 0,
        // },
        notes: '',
        extras: [],

        // rating: null,
        // feedback: null,
      });
    } else {
      setInstallReportInfo(data);
      mapStockData(data);
    }

    // data === undefined ? console.log('UNDEFINED') : console.log('DEFINED');
    // console.log(ticketData.install_report['training']);
    // setTrainingData(ticketData.install_report['training']);
  }, [ticketData]);

  const mapStockData = async (data) => {
    let stock = [];
    try {
      stock = [...data.extras];
    } catch (error) {
      stock = [];
    }
    setRowsStockData(stock);
  };

  const mltsName = location.state.install_ticket.tech_assigned_name;

  const [installReportInfo, setInstallReportInfo] = useState({});

  const navigateNew = useNavigate();
  // const [filteredSerialNumbersList, setFilteredSerialNumbersList] = useState();

  const [cabinetsList, setCabinetsList] = useState([]);
  // const [cabId, setCabId] = useState('');
  const [activeCab, setActiveCab] = useState({});

  const [cabinetType, setCabinetType] = useState([
    {
      id: activeCab.cabId,
      name: activeCab.cabType,
    },
  ]);

  useEffect(() => {
    let cabinet = cabinetType;
    // let cabinetTypes = [...cabinetsList];
    if (cabinet === undefined || cabinet === undefined || cabinet === []) {
      setCabinetsList([{ id: '1001', name: 'No Info' }]);
    } else {
      setCabinetsList((cabinetsList) => [...cabinetsList]);
    }
  }, [cabinetType]);

  const [stockList, setStockList] = useState([]);

  useEffect(() => {
    getStock('spares').then((data) => {
      setStockList(data.data.value);
    });
  }, []);

  const [gasList, setGasList] = useState([]);

  useEffect(() => {
    getStock('gas').then((data) => {
      setGasList(data.data.value);
    });
  }, []);

  // const [orderNumber, setOrderNumber] = useState(null);

  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function
  const [forceUpdate, setForceUpdate] = useState(1);

  const [rowsCabData, setRowsCabData] = useState(
    // location.state.install_ticket.serial_numbers
    []
  );
  const [rowsStockData, setRowsStockData] = useState(
    installReportInfo.extras || []
  );
  const [notes, setNotes] = useState(location.state?.install_report?.notes);

  useEffect(() => {
    const inCabs = location.state.install_ticket.serial_numbers;
    let outCabs = [];
    outCabs = inCabs.map((cab, key) => ({ ...cab, rowId: key }));
    setRowsCabData(outCabs);
  }, []);

  const updateCabRow = (data) => {
    let oldData = [...rowsCabData];
    const newData = oldData.map((obj) => {
      if (obj.rowId === data.rowId) {
        return {
          ...obj,
          rowId: data.rowId,
          id: data.id,
          cabId: data.cabId,
          cabType: data.cabType,
          serialId: data.serialId,
          serialNo: data.serialNo,
          temprature: data.temprature,
          snCheck: data.snCheck,
        };
      }
      return obj;
    });

    setRowsCabData(newData);
  };

  const removeCabRow = (data) => {
    let oldData = [...rowsCabData];
    // console.log(data);

    let tempData = oldData.slice().filter((item) => item.id !== data);

    setRowsCabData(tempData);
  };

  const [timeDat, setTimeDat] = useState('time');

  useEffect(() => {
    checkClock(location.state.install_ticket.id).then((data) => {
      // console.log(data.data.value.first_start_ts);
      setTimeDat(data.data.value.first_start_ts);
    });
  }, [location]);

  // useEffect(
  //   () => setRowsCabData(location.state.install_ticket.serial_numbers),
  //   [location.state.install_ticket.serial_numbers]
  // );

  const handleRowsStockChange = async (arr) => {
    const result = await addStock(arr);
    setRowsStockData(result);
  };

  const updateStockRow = (data, adjustmentType) => {
    let oldData = [...rowsStockData];

    // console.log('DATA', data, adjustmentType);

    const existingItems = oldData.filter((item) => {
      return item.id === data.id;
    });

    if (existingItems.length > 0) {
      enqNotification('This item already exists', 'warning');
    } else {
      const newData = oldData.map((obj) => {
        if (obj.id === data.rowId) {
          return {
            ...obj,
            id: data.id,
            qty: data.qty,
            description: data.description,
            code: data.code,
          };
        }
        return obj;
      });

      setRowsStockData(newData);
    }
  };

  const removeStockRow = (data) => {
    let oldData = [...rowsStockData];
    // console.log(data);

    let tempData = oldData.slice().filter((item) => item.id !== data);

    setRowsStockData(tempData);
  };

  const handleCheckList = (name, value) => {
    let tmpData = { ...checkListData };
    tmpData = { ...tmpData, [name]: value };
    setCheckListData(tmpData);
  };

  const handleTraining = (name, value) => {
    let tmpData = { ...trainingData };
    tmpData = { ...tmpData, [name]: value };
    setTrainingData(tmpData);
  };

  const combineData = () => {
    const validStock = rowsStockData.filter((item) => {
      return (
        item.description.toLowerCase() !== 'select description' &&
        item.code.toLowerCase() !== 'select stock code'
      );
    });

    setRowsStockData(validStock);

    let ticketBlob = {
      install_ticket: {
        serial_numbers: rowsCabData,
        extras: rowsStockData,
      },
      install_report: {
        check_list: checkListData,
        training: trainingData,
        notes: notes,
        extras: {
          ticket_shelving: {},
          tech_extras: {},
        },
      },
    };

    return ticketBlob;
  };

  const ticketUpdate = () => {
    const DataBlob = { ...combineData() };
    // console.log('DATA BLOB', DataBlob);
    //Get JWT from storage
    let JWT = localStorage.getItem('JWT_Key');
    //Set default Headers
    let headers = {
      'content-type': 'application/JSON',
    };
    //Set JWT in header if available
    if (JWT) {
      headers['x-api-key'] = JWT;
    }
    let body = {};
    body = DataBlob;
    const request = new Request(
      `${APIROOT}/api/r2_install_tickets/${location.state.install_ticket.id}`,
      {
        method: 'post',
        headers,
        body: JSON.stringify(body),
      }
    );
    fetch(request)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error(`Failed to save ticket`);
        }
      })
      .then((data) => {
        let parsed = JSON.parse(data);
        if (parsed.success === true) {
          //Update JWT if required
          // console.log(
          //   'here with path',
          //   `${APIROOT}/api/repair-tickets/${location.state.id}`
          // );
          if (parsed.JWT) {
            localStorage.setItem('JWT_Key', parsed.JWT);
          }
          // navigateNew(`/tech/tech_ticket_view/installreport`, {
          //   replace: true,
          //   state: location.state,
          // });
          enqNotification('Saved successfully', 'success');
          setForceUpdate(forceUpdate + 1);
        } else {
          //Force logout
          if (parsed.message === 'Please login') {
            logout(() => {
              enqNotification('Session Expired', 'warning');
            });
          } else {
            enqNotification(parsed.message, 'error');
          }
        }
      })
      .catch((error) => {
        enqNotification(
          typeof error == 'string' ? error : `Connection Error !! ${error}`,
          'error'
        );
      });
  };

  return (
    <Box sx={viewBox}>
      <Stack spacing={2} ref={componentRef} className='main-style'>
        <Grid
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
        >
          <Grid
            container
            direction='row'
            justify='flex-end'
            alignItems='center'
            className='justify_print'
          >
            <Grid item xs={12} md={4} style={{ textAlign: 'left' }}>
              <Typography
                variant='h6'
                fontWeight='700'
                fontSize={28}
                paddingLeft={'5px'}
                className='justify_print'
              >
                TICKET NR:{' '}
                {defineTicketNumber(
                  'install',
                  location.state.install_ticket.id,
                  5,
                  'I'
                )}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              style={{ textAlign: 'center' }}
              className='justify_print'
            >
              <Typography
                variant='h6'
                fontWeight='700'
                fontSize={28}
                className='justify_print'
              >
                INSTALLATION REPORT
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <DocsLogo className='justify_logo_print' />
            </Grid>
          </Grid>

          <Grid
            container
            margin={0}
            // rowSpacing={0}
            columnSpacing={{ xs: 1 }}
            // rowGap={0}
            style={{ border: '1 solid black', margin: 0 }}
          >
            <InstallReportCustomerInfo
              className='p-print-avoid-break'
              // timeData={timeDat}
              installReportInfo={installReportInfo}
              // orderNo={installReportInfo.order_number}
              // grnNo={installReportInfo.grn_number}
              customerData={location.state.install_ticket}
              setInstallReportInfo={(id, value) =>
                setInstallReportInfo({ ...installReportInfo, [id]: value })
              }
            />
            <Grid
              className='p-print-avoid-break'
              container
              rowSpacing={0}
              margin={0}
              columnSpacing={{ xs: 0 }}
              rowGap={0}
              style={{ marginLeft: 0, marginRight: 0 }}
            >
              <Grid
                item
                xs={12}
                md={12}
                style={{ textAlign: 'left' }}
                marginTop='10px'
              >
                <Typography variant='h6' fontWeight='700'>
                  Checklist
                </Typography>
              </Grid>
            </Grid>

            {/* <Grid
              className='p-print-avoid-break'
              container
              rowSpacing={0}
              margin={0}
              columnSpacing={{ xs: 0 }}
              rowGap={0}
              style={{ marginLeft: 0, marginRight: 0 }}
            > */}
            <InstallReportChekList
              sx={{ marginTop: '10px' }}
              checkListData={checkListData}
              handleCheckList={(name, value) => handleCheckList(name, value)}
            />
            {/* </Grid> */}
            <Grid
              className='p-print-avoid-break'
              container
              rowSpacing={0}
              margin={0}
              columnSpacing={{ xs: 0 }}
              rowGap={0}
              style={{ marginLeft: 0, marginRight: 0 }}
            >
              <Grid
                item
                xs={12}
                md={12}
                style={{ textAlign: 'left' }}
                marginTop='10px'
              >
                <Typography variant='h6' fontWeight='700'>
                  Training
                </Typography>
              </Grid>
              <InstallReportTraining
                sx={{ marginTop: '10px' }}
                trainingData={trainingData}
                handleTraining={(name, value) => handleTraining(name, value)}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          className='p-print-avoid-break'
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
        >
          <Grid item xs={6} md={6} style={{ textAlign: 'left' }}>
            <Typography variant='h6' fontWeight='700'>
              Cabinet Details
            </Typography>
          </Grid>
          <Grid item xs={6} md={6} style={{ textAlign: 'left' }}>
            {/* <Button
              className='d-print-none'
              variant='outlined'
              sx={{ float: 'right', fontWeight: '700' }}
              onClick={() => handleCabRowsChange(rowsCabData)}
            >
              Add Cabinet
            </Button> */}
          </Grid>
          <InstallReportCabinetDetails
            updateCabRow={(data) => updateCabRow(data)}
            removeCabRow={(data) => removeCabRow(data)}
            customerName={customerName}
            rowsData={rowsCabData}
          />
        </Grid>
        <Grid
          className='p-print-avoid-break'
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
        >
          <Grid item xs={6} md={6} style={{ textAlign: 'left' }}>
            <Typography variant='h6' fontWeight='700'>
              Extra Materials Used
            </Typography>
          </Grid>
          <Grid item xs={6} md={6} style={{ textAlign: 'left' }}>
            <Button
              className='d-print-none'
              variant='outlined'
              sx={{ float: 'right', fontWeight: '700' }}
              onClick={() => handleRowsStockChange(rowsStockData)}
            >
              Add Stock Item
            </Button>
          </Grid>
          <StockUsed
            updateStockRow={(data, adjustmentType) =>
              updateStockRow(data, adjustmentType)
            }
            removeStockRow={(data) => removeStockRow(data)}
            rowsStockData={rowsStockData}
          />
          {/* <InstallReportGas
            gasList={gasList}
            gasValues={installReportInfo}
            setGasType={(data) =>
              setInstallReportInfo({ ...installReportInfo, gas_type: data })
            }
            setGasIn={(data) =>
              setInstallReportInfo({ ...installReportInfo, gas_in: data })
            }
            setGasOut={(data) =>
              setInstallReportInfo({ ...installReportInfo, gas_out: data })
            }
            setCalcGasUsed={(data) =>
              setInstallReportInfo({ ...installReportInfo, gas_used: data })
            }
          /> */}
        </Grid>
        <Grid
          className='p-print-avoid-break'
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
        >
          <InstallReportNotes
            className='p-print-avoid-break'
            // notesType='Notes:'
            notesInfo={notes}
            setNotes={(data) => {
              setNotes(data);
            }}
          />
        </Grid>

        <Grid
          className='p-print-avoid-break'
          container
          rowSpacing={0}
          margin={0}
          columnSpacing={{ xs: 0 }}
          rowGap={0}
          style={{ marginLeft: 0, marginRight: 0 }}
        >
          <InstallReportSignatures mltsEmployee={mltsName} />
        </Grid>
      </Stack>
      <Box sx={{ float: 'right' }}>
        <Button
          variant='contained'
          onClick={() => {
            ticketUpdate();
          }}
          sx={{ margin: '15px 0 0 15px' }}
        >
          Save
        </Button>
        <Button
          variant='contained'
          sx={{ margin: '15px 0 0 15px' }}
          onClick={handlePrint}
        >
          Print
        </Button>

        <Button
          onClick={() =>
            navigateNew(`/tech/tech_install_ticket_view`, {
              replace: true,
              state: location.state.install_ticket,
            })
          }
          variant='contained'
          sx={{ margin: '15px 0 0 15px' }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
}

//FUNCTIONS
async function serialsByCustomer(customerName, cabinetType) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {
    pagereq: {
      filter: {
        fullfilter: [
          {
            field: 'store_name',
            search: customerName,
            strict: true,
          },
          // {
          //   field: 'cabinet_type_id',
          //   search: cabinetType,
          //   strict: true,
          // },
        ],
      },
    },
  };
  const request = new Request(`${APIROOT}/api/serialnumbers`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}

//STOCK
async function getStock(type) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {
    pagereq: {
      filter: {
        fullfilter: [
          {
            field: 'type',
            search: type,
            strict: true,
          },
        ],
      },
    },
  };

  const request = new Request(`${APIROOT}/api/consumables`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}

//STYLE
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 1024,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

//TICKET DATA
async function getTicketDatabyId(TicketId) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {};

  const request = new Request(`${APIROOT}/api/r2_install_tickets/${TicketId}`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}

const addCabinet = (data) => {
  let rowId = data.length + 1;
  let newObj = [
    {
      id: rowId,
      cabType: 'add type',
      serialNo: 'add Serial No',
      description: '',
    },
  ];
  let newData = [...data, ...newObj];
  return new Promise((resolve) => {
    resolve(newData);
  });
};

const addStock = (data) => {
  let rowId = data.length + 1;
  let newObj = [
    {
      id: rowId,
      qty: '1',
      description: 'select description',
      code: 'select stock code',
    },
  ];
  let newData = [...data, ...newObj];
  return new Promise((resolve) => {
    resolve(newData);
  });
};

const removeStock = (data) => {
  let rowId = data.length + 1;
  let newObj = [
    {
      id: rowId,
      qty: '1',
      description: 'select description',
      code: 'select stock code',
    },
  ];
  let newData = [...data, ...newObj];
  return new Promise((resolve) => {
    resolve(newData);
  });
};

async function checkClock(ticketId) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };
  if (JWT) {
    headers['x-api-key'] = JWT;
  }
  let body = {
    fetch: 'ticket_hours_repair',
    fetchid: ticketId,
  };
  const request = new Request(`${APIROOT}/api/actions`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });
  const response = await fetch(request);

  const data = response.json();
  return data;
}
